module.exports = __webpack_public_path__ + "static/convidi_macbook2-672fcbc43ef28135fce84e025dfa13a0.png";